import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../hooks/AlertHook";

const SidebarAccount = (props) => {
  const [userEmail, setUserEmail] = useState("");
  const navigate = useNavigate();
  const alerta = useAlert();

  const logout = () => {
    localStorage.removeItem("BACK_API");
    alerta.setHomeLink("/auth/login");
    navigate("/auth/login");
  };

  useEffect(() => {
    const { email } = JSON.parse(localStorage.getItem("BACK_API")) || {};
    setUserEmail(email);
  }, []);

  return (
    <div className="flex-shrink-0 flex border-t bg-white border-gray-200 p-4">
      <a
        href="javascript:void(0)"
        className="flex-shrink-0 w-full group block"
        onClick={logout}
      >
        <div className="flex items-center">
          <div>
            <div className="h-8 w-8 text-vide-purple rounded-full font-bold  flex items-center justify-center">
              BR
            </div>
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
              {userEmail}
            </p>
            <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">
              Account Settings
            </p>
          </div>
        </div>
      </a>
    </div>
  );
};

export default SidebarAccount;
